import { SimpleCommand } from './../../../commanding/SimpleCommand';


import { EnvGlobalsHandler } from "../../EnvGlobalsHandler";
import { IEnvironmentGlobals } from "../../IEnvironmentGlobals";

export class BasicClientCommand extends SimpleCommand {
    constructor(singleExecution: boolean = false) {
        super(singleExecution);
    }

    protected get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }
}

